import React from 'react';
import DropdownGeneral from '../DropdownGeneral/DropdownGeneral';
import { DropdownStatusProps } from './DropdownStatus.type';
const list = [
  {
    value: 'all',
    label: 'All Status'
  },
  {
    value: '3',
    label: 'Approved'
  },
  {
    value: '2',
    label: 'On Review'
  },
  {
    value: '1',
    label: 'Rejected'
  },
  {
    value: '0',
    label: 'Draft'
  }
];
const DropdownStatus: React.FC<DropdownStatusProps> = ({
  defaultValue,
  onChange,
  showUncovered = false,
  disabled = false
}) => {
  const listData = showUncovered
    ? [
        ...list,
        {
          value: '4',
          label: 'Uncovered'
        }
      ]
    : list;
  return (
    <DropdownGeneral
      disabled={disabled}
      data-testid="dropdown-status"
      placeholder="Anomaly Rating"
      onChange={onChange}
      list={listData}
      defaultValue={defaultValue ?? 'all'}
    />
  );
};

export default DropdownStatus;
